<template>
  <CErrorFullScreen
    class="pa-10 rounded-2"
    :description="t('canvasUI.browserApp.smartFoldersMissingConfig.noConfigDescription')"
    fit-parent
    icon="face-dotted"
    :title="t('canvasUI.browserApp.smartFoldersMissingConfig.pleaseConfigureSmartFolders')"
  >
    <CButton class="mt-3" @click="emit('configure')">
      <template #icon>
        <CIcon icon="cog" />
      </template>
      {{ t('canvasUI.browserApp.smartFoldersMissingConfig.configureSmartFolders') }}
    </CButton>
  </CErrorFullScreen>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import CErrorFullScreen from '@lib/components/CError/CErrorFullScreen.vue'
import CButton from '@lib/components/CButton/CButton.vue'
import CIcon from '@lib/components/CIcon/CIcon.vue'

const { t } = useI18n()

const emit = defineEmits<{
  configure: []
}>()
</script>
